import { formatHumanizedDuration } from "@intelligems/ig-utils/humanizeDuration";

/**
 * "for the next …" copy for a listen-window expiry (epoch ms). Shared by the
 * shipping-provider Runs tab and the Agentic Logic Recent runs panel.
 */
export const formatRemainingWindow = (
  expiresAt: number | null,
  now: number = Date.now()
): string => {
  if (expiresAt == null) {
    return "a few seconds";
  }
  const remainingMs = Math.max(0, expiresAt - now);
  if (remainingMs < 1_000) {
    return "a few seconds";
  }
  return formatHumanizedDuration(remainingMs);
};
